
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component({
  name: 'svg-icon-wrapper'
})
export default class extends Vue {
  @Prop({ default: '#fff' })
  color!: string;

  @Prop({
    default: 'md',
    validator: (value: string) => ['xs', 'sm', 'md', 'lg', 'xl'].includes(value)
  })
  size!: string;

  @Prop({ required: true })
  url!: string;

  get style() {
    return {
      mask: `url(${this.url}) no-repeat center / contain`,
      '-webkit-mask': `url(${this.url}) no-repeat center / contain`,
      backgroundColor: this.color
    };
  }
}
